/**
 * 禁用开发者工具
 * 仅在生产环境生效
 */

// 检测是否为生产环境
const isProduction = process.env.NODE_ENV === 'production'

if (isProduction) {
  // 1. 禁用右键菜单
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault()
    return false
  })

  // 2. 禁用快捷键
  document.addEventListener('keydown', function (e) {
    // F12
    if (e.keyCode === 123) {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+I (开发者工具)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+J (控制台)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
      e.preventDefault()
      return false
    }
    // Ctrl+Shift+C (元素选择器)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
      e.preventDefault()
      return false
    }
    // Ctrl+U (查看源码)
    if (e.ctrlKey && e.keyCode === 85) {
      e.preventDefault()
      return false
    }
    // Ctrl+S (保存)
    if (e.ctrlKey && e.keyCode === 83) {
      e.preventDefault()
      return false
    }
  })

  // 3. 检测开发者工具是否打开
  let devtools = { open: false }
  const threshold = 160

  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold
    const heightThreshold = window.outerHeight - window.innerHeight > threshold
    
    if (widthThreshold || heightThreshold) {
      if (!devtools.open) {
        devtools.open = true
        // 检测到开发者工具打开，可以执行一些操作
        console.clear()
        // 可选：重定向或显示警告
        // window.location.href = 'about:blank'
        // alert('请关闭开发者工具')
      }
    } else {
      devtools.open = false
    }
  }

  // 定期检测
  setInterval(checkDevTools, 500)

  // 4. debugger 陷阱（可选，可能会影响性能）
  let startTime = new Date()
  debugger
  let endTime = new Date()
  
  // 如果 debugger 暂停时间过长，说明开发者工具打开
  if (endTime - startTime > 100) {
    window.location.href = 'about:blank'
  }

  // 5. 禁用 console（可选）
  // window.console = {
  //   log: function () {},
  //   warn: function () {},
  //   error: function () {},
  //   info: function () {},
  //   debug: function () {},
  //   table: function () {},
  //   clear: function () {}
  // }

  // 6. 检测 Firebug
  if (window.console && window.console.firebug) {
    window.location.href = 'about:blank'
  }

  // 7. 禁用选择文本
  document.addEventListener('selectstart', function (e) {
    e.preventDefault()
    return false
  })

  // 8. 禁用拖拽
  document.addEventListener('dragstart', function (e) {
    e.preventDefault()
    return false
  })

  console.log('开发者工具保护已启用')
}



// WEBPACK FOOTER //
// ./src/utils/disable-devtools.js